export const ADDON_FORM_RECEIVED = 'ADDON_FORM_RECEIVED' as const;
export const ADDON_FORM_REQUEST_FAILED = 'ADDON_FORM_REQUEST_FAILED' as const;
export const ADDON_FORM_REQUEST_TIMED_OUT = 'ADDON_FORM_REQUEST_TIMED_OUT' as const;
export const ADDON_FORM_REQUESTED = 'ADDON_FORM_REQUESTED' as const;
export const ADDON_FORM_RESET_REQUESTED = 'ADDON_FORM_RESET_REQUESTED' as const;
export const ADDON_FORM_RESET = 'ADDON_FORM_RESET' as const;
export const ADDON_FORM_RESET_FAILED = 'ADDON_FORM_RESET_FAILED' as const;
export const ADDON_NOTIONAL_CHANGED = 'ADDON_NOTIONAL_CHANGED' as const;
export const ADDON_DAILY_NUMBER_OF_SHARES_CHANGED = 'ADDON_DAILY_NUMBER_OF_SHARES_CHANGED' as const;
export const ADDON_NOTIONAL_TYPE_CHANGED = 'ADDON_NOTIONAL_TYPE_CHANGED' as const;
export const ADDON_CLIENT_CHANGED = 'ADDON_CLIENT_CHANGED' as const;
export const ADDON_DEAL_SPLIT_CHANGED = 'ADDON_DEAL_SPLIT_CHANGED' as const;
export const ADDON_TRADE_CLIENT_SIDE_CHANGED = 'ADDON_TRADE_CLIENT_SIDE_CHANGED' as const;
export const ADDON_ACTION_CHANGED = 'ADDON_ACTION_CHANGED' as const;
export const ADDON_MERGE_DEALS_REQUESTED_CHANGED = 'ADDON_MERGE_DEALS_REQUESTED_CHANGED' as const;
export const ADDON_SELECTED_TRADE_REFERENCE_CHANGED = 'ADDON_SELECTED_TRADE_REFERENCE_CHANGED' as const;
export const ADDON_CUSTODIANS_RELOADED = 'ADDON_CUSTODIANS_RELOADED' as const;
export const ADDON_CUSTODIANS_RELOAD_FAILED = 'ADDON_CUSTODIANS_RELOAD_FAILED' as const;
export const ADDON_REMUNERATION_MODE_CHANGED = 'ADDON_REMUNERATION_MODE_CHANGED' as const;
export const ADDON_SOLVE_MODE_CHANGED = 'ADDON_SOLVE_MODE_CHANGED' as const;
export const ADDON_X_MARGIN_CHANGED = 'ADDON_X_MARGIN_CHANGED' as const;
export const ADDON_UPFRONT_FEE_CHANGED = 'ADDON_UPFRONT_FEE_CHANGED' as const;
export const ADDON_OFFER_PRICE_CHANGED = 'ADDON_OFFER_PRICE_CHANGED' as const;
export const ADDON_FIXED_AMOUNT_CHANGED = 'ADDON_FIXED_AMOUNT_CHANGED' as const;
export const ADDON_FUNDING_LOCK_DATE_CHANGED = 'ADDON_FUNDING_LOCK_DATE_CHANGED' as const;
export const ADDON_BACK_TO_BACK_IS_BACK_TO_BACK_CHANGED = 'ADDON_BACK_TO_BACK_IS_BACK_TO_BACK_CHANGED' as const;
export const ADDON_BACK_TO_BACK_TYPE_CHANGED = 'ADDON_BACK_TO_BACK_TYPE_CHANGED' as const;
export const ADDON_BACK_TO_BACK_FILE_CODE_CHANGED = 'ADDON_BACK_TO_BACK_FILE_CODE_CHANGED' as const;
export const ADDON_BACK_TO_BACK_NOTE_NOMINAL_CHANGED = 'ADDON_BACK_TO_BACK_NOTE_NOMINAL_CHANGED' as const;
export const ADDON_BACK_TO_BACK_IS_DELTA_ADJUSTED_CHANGED = 'ADDON_BACK_TO_BACK_IS_DELTA_ADJUSTED_CHANGED' as const;
export const ADDON_BACK_TO_BACK_IS_DELAYED_BACK_TO_BACK_CHANGED =
  'ADDON_BACK_TO_BACK_IS_DELAYED_BACK_TO_BACK_CHANGED' as const;
export const ADDON_SALES_BENEFICIARIES_CHANGED = 'ADDON_SALES_BENEFICIARIES_CHANGED' as const;
export const ADDON_SALES_DESK_CHANGED = 'ADDON_SALES_DESK_CHANGED' as const;
export const ADDON_SALES_BENEFICIARIES_RELOADED = 'ADDON_SALES_BENEFICIARIES_RELOADED' as const;
export const ADDON_SALES_BENEFICIARIES_RELOAD_FAILED = 'ADDON_SALES_BENEFICIARIES_RELOAD_FAILED' as const;
export const ADDON_SALES_DESKS_RELOADED = 'ADDON_SALES_DESKS_RELOADED' as const;
export const ADDON_SALES_DESKS_RELOAD_FAILED = 'ADDON_SALES_DESKS_RELOAD_FAILED' as const;

export const ADDON_QUOTE_REQUESTED = 'ADDON_QUOTE_REQUESTED' as const;
export const ADDON_QUOTE_CANCELLED = 'ADDON_QUOTE_CANCELLED' as const;
export const ADDON_QUOTE_ACKED = 'ADDON_QUOTE_ACKED' as const;
export const ADDON_QUOTE_REMOVED = 'ADDON_QUOTE_REMOVED' as const;
export const ADDON_QUOTE_STALE = 'ADDON_QUOTE_STALE' as const;
export const ADDON_QUOTE_PRICE_INCONSISTENT = 'ADDON_QUOTE_PRICE_INCONSISTENT' as const;

export const ADDON_QUOTE_RECEIVED = 'ADDON_QUOTE_RECEIVED' as const;
export const ADDON_QUOTE_RESULT_FAILED = 'ADDON_QUOTE_RESULT_FAILED' as const;
export const ADDON_QUOTE_REQUEST_FAILED = 'ADDON_QUOTE_REQUEST_FAILED' as const;
export const ADDON_QUOTE_DENIED = 'ADDON_QUOTE_DENIED' as const;
export const ADDON_QUOTE_TRADE_REQUESTED = 'ADDON_QUOTE_TRADE_REQUESTED' as const;
export const ADDON_QUOTE_TRADE_REQUEST_REJECTED = 'ADDON_QUOTE_TRADE_REQUEST_REJECTED' as const;
export const ADDON_QUOTE_TRADE_FAILED = 'ADDON_QUOTE_TRADE_FAILED' as const;
export const ADDON_QUOTE_TRADE_SENT = 'ADDON_QUOTE_TRADE_SENT' as const;
export const ADDON_QUOTE_TRADE_REJECTED = 'ADDON_QUOTE_TRADE_REJECTED' as const;
export const ADDON_TRADE_AUTH_RECEIVED = 'ADDON_TRADE_AUTH_RECEIVED' as const;
export const ADDON_TRADE_AUTH_TIMEOUT = 'ADDON_TRADE_AUTH_TIMEOUT' as const;
export const ADDON_TRADE_AUTH_ENDED = 'ADDON_TRADE_AUTH_ENDED' as const;
export const ADDON_QUOTE_TRADE_DONE = 'ADDON_QUOTE_TRADE_DONE' as const;
export const ADDON_QUOTE_PRICE_PUBLISHED = 'ADDON_QUOTE_PRICE_PUBLISHED' as const;
export const ADDON_QUOTE_ACTIVE_FORM_TAB_CHANGED = 'ADDON_QUOTE_ACTIVE_FORM_TAB_CHANGED' as const;
export const ADDON_QUOTE_PRICE_ENHANCED = 'ADDON_QUOTE_PRICE_ENHANCED' as const;
export const ADDON_QUOTE_SPONSO_FEE = 'ADDON_QUOTE_SPONSO_FEE' as const;

export const ADDON_MERGEABLE_DEALS_LOAD_REQUESTED = 'ADDON_MERGE_DEALS_LOAD_REQUESTED' as const;
export const ADDON_MERGEABLE_DEALS_LOADED = 'ADDON_MERGE_DEALS_LOADED' as const;
export const ADDON_MERGEABLE_DEALS_LOAD_REQUEST_FAILED = 'ADDON_MERGE_DEALS_LOAD_REQUEST_FAILED' as const;
export const ADDON_MERGEABLE_DEALS_LOAD_REQUEST_TIMED_OUT = 'ADDON_MERGE_DEALS_LOAD_REQUEST_TIMED_OUT' as const;
